import React from 'react'
import { useTranslation } from 'react-i18next'

import { BaseModalType } from '@context/ModalsContext'

import { Body1 } from '@ui/Typography'
import { Modal } from '@ui/components/Modal'

import { Box } from '@shared/components/Box'

interface CloseTradeModalProps {
  onConfirm: () => void
}

export const CancelAllOrdersModal: BaseModalType<CloseTradeModalProps> = (props) => {
  const { close, onConfirm } = props
  const { t } = useTranslation()
  return (
    <Modal>
      <Modal.Header canClose>{t('Portfolio.Cancel All Orders')}</Modal.Header>
      <Modal.Body>
        <Box fullWidth>
          <Body1>{t('Portfolio.Are you sure you want to cancel all pending orders')}</Body1>
        </Box>
      </Modal.Body>
      <Modal.Footer>
        <Modal.Footer.Secondary onClick={close}>{t('Cancel')}</Modal.Footer.Secondary>
        <Modal.Footer.Primary
          onClick={() => {
            onConfirm()
            close()
          }}
        >
          {t('Confirm')}
        </Modal.Footer.Primary>
      </Modal.Footer>
    </Modal>
  )
}
